import * as React from 'react';
import { components } from 'react-select';
export const MultiValueLabel = (internalProps) => (React.createElement(components.MultiValueLabel, Object.assign({}, internalProps), internalProps.data.label));
//# sourceMappingURL=MultiValueLabel.js.map